/**
 * InviteStudentsModal
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Alert, Button, Modal } from 'react-bootstrap';
import { useApi2call, useSelectFromLocation } from 'containers/Api2/index.js';
import messages from '../messages.js';
import InviteFrame from '../../../../Users/InviteUsers/InviteFrame.jsx';

function InviteStudentsModal(props) {
  const { show, onHide, counts } = props;
  const { activeCount, totalCount, parentCount } = counts;
  const api2call = useApi2call();
  const group = useSelectFromLocation();
  const groupId = group.groupId || group.id;

  const printLink = `#print/student/${groupId}`;
  const values = { count: totalCount - activeCount };
  function handleEmail() {
    api2call({
      method: 'POST',
      url: 'sa/users/student/parentEmailInvites',
      version: 2,
      body: {
        groups: [groupId],
      },
      success: { ...messages.invitationsSent, values: { count: parentCount } },
    });
    onHide();
  }
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title><FormattedMessage {...messages.inviteStudents} /></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <InviteFrame>
          <InviteFrame.Print className="panel py-4 d-flex flex-column">
            <div className="flex-grow-1">
              <p className="form-text text-center px-4 pb-3"><FormattedMessage {...messages.distributePrints} /></p>
              <Alert variant="info"><FormattedMessage {...messages.printCount} values={values} /></Alert>
            </div>
            <div>
              <Button variant="primary" className="ms-4 mt-4" href={printLink}><FormattedMessage {...messages.invitePrintButton} /></Button>
            </div>
          </InviteFrame.Print>
          <InviteFrame.Email className="panel py-4">
            <div className="flex-grow-1">
              <p className="form-text text-center px-4 pb-3"><FormattedMessage {...messages.connectedParentsEmail} /></p>
              <Alert variant="info"><FormattedMessage {...messages.numberInvitationsStudents} values={counts} /></Alert>
              <Alert variant="warning"><FormattedMessage {...messages.countUnconnected} values={counts} /></Alert>
            </div>
            <div>
              <Button variant="primary" className="ms-4 mt-4" onClick={handleEmail}><FormattedMessage {...messages.send} /></Button>
            </div>
          </InviteFrame.Email>
        </InviteFrame>
      </Modal.Body>
    </Modal>
  );
}

InviteStudentsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  counts: PropTypes.object.isRequired,
};

export default InviteStudentsModal;
